import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React, { Component, forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Buttons';
import CancelButton from './CancelButton';

class DeleteButtonBase extends Component {
  state = { open: false };

  toggle = event => {
    event.stopPropagation();
    this.setState(prevState => ({ open: !prevState.open }));
  };

  onConfirm = event => {
    this.props.onClick();
    this.toggle(event);
  };

  render() {
    const {
      children,
      itemName = 'item',
      showIconButton,
      forwardedRef,
      title,
      description,
      confirmText,
      ...rest
    } = this.props;
    const { open } = this.state;
    return (
      <>
        {showIconButton ? (
          <IconButton ref={forwardedRef} onClick={this.toggle} size="large" {...rest}>
            {children}
          </IconButton>
        ) : (
          <Button color="error" onClick={this.toggle} {...rest}>
            {children || <FormattedMessage id="DeleteButton-label-delete" defaultMessage="Delete" />}
          </Button>
        )}
        <Dialog onClose={this.toggle} open={open}>
          <DialogTitle>
            {title || <FormattedMessage id="DeleteButton-dialog-title" defaultMessage="Confirm deletion" />}
          </DialogTitle>
          <DialogContent>
            {description ? (
              description
            ) : (
              <Typography variant="body1">
                <FormattedMessage
                  id="DeleteButton-dialog-message"
                  values={{ itemName }}
                  defaultMessage="Are you sure you want to delete {itemName}?"
                />
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <CancelButton onClick={this.toggle} />
            <Button color="error" variant="contained" onClick={this.onConfirm}>
              {confirmText || <FormattedMessage id="DeleteButton-label-delete" defaultMessage="Delete" />}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

const DeleteButton = forwardRef((props, ref) => <DeleteButtonBase {...props} forwardedRef={ref} />);

export default DeleteButton;
